var _path, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23,12.1v0.7v0l0,1.5c0,0.1-0.1,0.2-0.2,0.2h-3.1c0,0,0,0,0,0c0-1.2-1-2.2-2.2-2.2c-1.2,0-2.2,1-2.2,2.2v0h-7 c0,0,0,0,0,0c0-1.2-1-2.2-2.2-2.2c-1.2,0-2.2,1-2.2,2.2v0H1.5c-0.3,0-0.5-0.2-0.5-0.5V12c0-0.3,0.1-0.6,0.3-0.8 c0.2-0.4,0.6-0.6,1.1-0.6h2.2l0.2-0.2l2.1-2.2C7.1,7.9,7.5,7.7,8,7.7h5.9c0.5,0,0.9,0.2,1.2,0.5l1.9,2l2.2,0.2l2.5,0.2 c0.2,0,0.4,0.1,0.6,0.3c0.1,0.1,0.3,0.3,0.4,0.4C23,11.6,23,11.8,23,12.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M11.8,10.6h5l-1.9-2c-0.2-0.3-0.6-0.4-0.9-0.4h-2.2L11.8,10.6L11.8,10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M11.3,8.1H8.4c-0.4,0-0.7,0.1-0.9,0.4l-2,2h5.7L11.3,8.1L11.3,8.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#000"
    },
    cx: 6.1,
    cy: 14.5,
    rx: 1.8,
    ry: 1.8
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.1,
    cy: 14.5,
    r: 1.1
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 6.1,
    cy: 14.5,
    r: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 17.5,
    cy: 14.5,
    r: 1.8
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 14.5,
    r: 1.1
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 17.5,
    cy: 14.5,
    r: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M1.9,11.1v0.7c0,0.5-0.4,0.8-0.8,0.8H1v-0.8c0-0.3,0.1-0.6,0.3-0.8C1.3,11.1,1.9,11.1,1.9,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M23,12.1v0.7v0h-0.1c-0.5,0-1-0.4-1-0.7v-0.4c0-0.1,0.1-0.2,0.3-0.2h0.7C23,11.6,23,11.8,23,12.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11,
    style: {
      fill: "#000"
    },
    width: 0.8,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.4,
    y: 11,
    style: {
      fill: "#000"
    },
    width: 0.8,
    height: 0.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.40f11c55c5c2a7ada3c89f16657baa97.svg";
export { ForwardRef as ReactComponent };